import { useEffect, useState } from "react";

interface PaginationResponse<T> {
  response?: {
    content: T[];
    last?: boolean;
  };
}

interface UseDropdownPaginationProps<T> {
  data?: PaginationResponse<T>;
  pageSize: number;
}

export const useDropdownPagination = <T>({
  data,
  pageSize,
}: UseDropdownPaginationProps<T>) => {
  const [list, setList] = useState<T[]>([]);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    if (data?.response?.content) {
      const newData = data.response.content;

      setList((prev) => [...prev, ...newData]);

      if (data.response.last !== undefined) {
        setHasMore(!data.response.last);
      } else {
        setHasMore(newData.length === pageSize);
      }
    }
  }, [data]);

  const reset = () => {
    setList([]);
    setHasMore(true);
  };

  return {
    list,
    hasMore,
    reset,
  };
};
